// extracted by mini-css-extract-plugin
export var sliderRange = "_nr-2";
export var sliderRoot = "_nr-0";
export var sliderThumb = "_nr-3";
export var sliderTrack = "_nr-1";